import { render } from "./AccessDeniedView.vue?vue&type=template&id=2c7da3cc&scoped=true"
import script from "./AccessDeniedView.vue?vue&type=script&lang=js"
export * from "./AccessDeniedView.vue?vue&type=script&lang=js"

import "./AccessDeniedView.vue?vue&type=style&index=0&id=2c7da3cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c7da3cc"]])

export default __exports__